import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    number: "01",
    title: "URLを入力",
    description:
      "商品ページやLPのURLを入力するだけ。AIが商材情報を自動で読み取り、分析を開始します。",
    screenshot: "/lp/screenshots/ui-product-select-form.png",
  },
  {
    number: "02",
    title: "AIが広告を設計",
    description:
      "商材分析、競合との差別化、ターゲット設計、訴求メッセージの構築まで、AIが広告プランナーの仕事を自動実行。",
    screenshot: "/lp/screenshots/ui-product-select-images.png",
  },
  {
    number: "03",
    title: "ボタンひとつで量産",
    description:
      "サイズを選んで生成ボタンを押すだけ。数分で複数パターンのバナーが完成。バリエーション展開もワンクリック。",
    screenshot: "/lp/screenshots/ui-banner-gallery.png",
  },
];

const HowItWorksSection: React.FC = () => {
  const publicUrl = process.env.PUBLIC_URL || "";

  return (
    <section id="how" className="py-24 md:py-40">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-20"
        >
          <span className="inline-flex items-center h-7 px-3 rounded-full bg-[#1d1926]/5 text-[#1d1926]/60 text-[13px] font-medium tracking-[0.04em]">
            How it works
          </span>
          <h2 className="mt-5 text-[36px] md:text-[64px] font-extrabold tracking-[-0.03em]">
            3ステップで完結。
          </h2>
        </motion.div>

        <div className="space-y-24 md:space-y-32">
          {steps.map((step, i) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center"
              style={i % 2 === 1 ? { direction: "rtl" } : {}}
            >
              <div style={{ direction: "ltr" }}>
                <span className="text-[120px] md:text-[160px] font-extrabold leading-none text-[#1d1926]/[0.08]">
                  {step.number}
                </span>
                <h3 className="-mt-6 text-[36px] md:text-[52px] lg:text-[64px] font-extrabold tracking-[-0.02em]">
                  {step.title}
                </h3>
                <p className="mt-4 text-[18px] text-[#1d1926]/60 leading-relaxed max-w-md">
                  {step.description}
                </p>
              </div>
              <div
                className="relative rounded-2xl overflow-hidden border border-[rgba(29,25,38,0.08)] shadow-[0_4px_24px_rgba(0,0,0,0.04)]"
                style={{ direction: "ltr" }}
              >
                <img
                  src={`${publicUrl}${step.screenshot}`}
                  alt={step.title}
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
